export default __webpack_public_path__ + "static/media/logo-agenix.38b0d1a0.png";